import Cookies from 'js-cookie';
import { sendGoogleTagEvent } from '../../analytics/googleTag';
import {
  REVIEW_SOURCE_KEY,
  GOOGLE_ADS_REVIEW_CONVERSION_ID,
  GOOGLE_ADS_REVIEW_ID,
} from '../constants';
import { hasGoogleAdsUserData, type GoogleAdsUserData } from '../../analytics/googleAdsUserData';

export const isReviewSource = (): boolean => Cookies.get(REVIEW_SOURCE_KEY) === '1';

export const sendReviewPurchaseConversion = (params: {
  transactionId: string | undefined;
  value: number;
  currency: string;
  userData?: GoogleAdsUserData;
}): void => {
  const { transactionId, value, currency, userData } = params;
  if (!isReviewSource()) return;

  const sendTo =
    GOOGLE_ADS_REVIEW_ID && GOOGLE_ADS_REVIEW_CONVERSION_ID
      ? `${GOOGLE_ADS_REVIEW_ID}/${GOOGLE_ADS_REVIEW_CONVERSION_ID}`
      : '';
  if (!sendTo) return;

  const payload: Record<string, unknown> = {
    send_to: sendTo,
    value,
    currency: currency || 'USD',
    transaction_id: transactionId || '',
  };
  if (userData && hasGoogleAdsUserData(userData)) {
    payload.user_data = userData;
  }

  sendGoogleTagEvent('conversion', payload);
};
